<template>
  <div class="m-4 mx-auto my-6 flex max-w-xl flex-col rounded-lg bg-white p-4">
    <h1 class="text-lg font-normal">
      How did you hear about us?
      <fa-icon
        class="text-vgorange pl-1 text-sm"
        icon="fa-regular fa-asterisk"
      />
    </h1>
    <v-textarea
      v-model="howHeard"
      data-cy="consult.howheard.input.how-heard"
      :error-messages="howHeardRules"
      rows="2"
      variant="outlined"
      maxlength="4000"
    ></v-textarea>
    <p class="text-lg font-normal">
      Virtual Gurus' social mission is to provide work opportunities for those
      from traditionally underrepresented communities in North America. Was this
      a factor in your decision to contact us?
      <fa-icon
        class="text-vgorange pl-1 text-sm"
        icon="fa-regular fa-asterisk"
      />
    </p>
    <v-radio-group v-model="socialMission" :error-messages="socialMissionRules">
      <v-radio
        v-for="(item, index) of socialMissionOptions"
        :key="index"
        :value="item"
      >
        <template #label>
          <p class="pl-3 text-sm">{{ item }}</p>
        </template></v-radio
      >
    </v-radio-group>
  </div>
</template>

<script>
import { getConsultState } from '@/services/consultService';

export default {
  name: 'HowHeard',
  props: {
    error: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update'],
  data() {
    return {
      howHeard: '',
      socialMission: '',
      socialMissionOptions: [
        'Yes, I knew about it, and it was a factor',
        `I didn't know about it before, but I'm glad to hear about it`,
        `No, it's not an important factor`,
      ],
    };
  },
  computed: {
    socialMissionRules() {
      return this.error === true && !this.socialMission ? ['required'] : [];
    },
    howHeardRules() {
      return this.error === true && !this.howHeard ? ['required'] : [];
    },
  },
  watch: {
    howHeard() {
      this.$emit('update', {
        key: 'howHeard',
        Q: 'How did you hear about us?',
        A: this.howHeard,
      });
    },
    socialMission() {
      this.$emit('update', {
        key: 'socialMission',
        Q: `Was Virtual Gurus' social mission one of the reasons that you visited us
      today?`,
        A: this.socialMission,
      });
    },
  },
  created() {
    this.howHeard =
      getConsultState().questions.find((item) => item.key === 'howHeard')?.A ||
      '';
    this.socialMission =
      getConsultState().questions.find((item) => item.key === 'socialMission')
        ?.A || '';
  },
};
</script>

<style></style>
